// React Dependencies
import React from 'react';

// External Dependencies
import _ from 'lodash';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { FixedSizeList } from 'react-window';
import { Grid, Typography, Button, Input } from '@material-ui/core';

// Internal Dependencies
import Header from './header';
import Loading from '../../global/Loading';
import apiService from '../../../services.js/apiService';
import { IsEmpty } from '../../../common/checks';
import { setMall } from '../../../actions/admin/uploadScrappedPromoAction';

class SelectMall extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      malls:       [],
      displayList: [],
      loading:     false,
    };
    this.onMallSelect = this.onMallSelect.bind(this);
    this.displayItem = this.displayItem.bind(this);
    this.onFilterChange = this.onFilterChange.bind(this);
  }

  componentDidMount() {
    this.getMalls();
  }

  async getMalls() {
    try {
      this.setState({ loading: true });
      const malls = _.orderBy(await apiService.getMalls(), ['name'], ['asc']);
      console.log('malls=');
      console.log(malls);
      this.setState({ loading: false, malls, displayList: malls });
    } catch (error) {
      this.setState({ loading: false });
      console.log('error getting malls data');
      console.log(error);
      toast.error(String(error));
    }
  }

  onMallSelect(mall) {
    console.log('selected mall=', mall);
    this.props.setMallDispatcher(mall.id, mall.name);
  }

  onFilterChange(evt) {
    console.log('evt=');
    console.log(evt.target.value);
    const keyword = String(evt.target.value);
    const { malls } = this.state;
    if (!IsEmpty(keyword)) {
      const mallFilter = malls.filter((mall) => mall.name.toLowerCase().includes(keyword.toLowerCase()));
      this.setState({ displayList: mallFilter });
    } else {
      this.setState({ displayList: malls });
    }
  }

  onBackPress() {
    console.log('back pressed');
  }

  displayItem({ index, style }) {
    // console.log('index=', index);
    return (
      <div style={{
        ...style,
      }}
      >
        <Button
          className="d-flex col align-items-center"
          style={{
            paddingTop:      15,
            paddingBottom:   15,
            backgroundColor: '#fff',
          }}
          onClick={() => this.onMallSelect(this.state.displayList[index])}
        >
          <Typography style={{}} variant="h6">{this.state.displayList[index].name}</Typography>
        </Button>
      </div>
    );
  }

  render() {
    return (
      <Grid container direction="column">
        <Header
          title="(Step 1/3) Select Mall"
        />
        <Grid item container xs={12} className="mt-4">
          <Input
            type="text"
            fullWidth
            placeholder="Filter"
            onChange={this.onFilterChange}
            inputProps={{
              style: {
                fontSize: 25,
              },
            }}
          />
        </Grid>
        <Grid container item xs={12} style={{}}>
          {
            !IsEmpty(this.state.displayList) && (
              <FixedSizeList
                height={500}
                width="100%"
                itemSize={50} // for vertical list, this is the row height
                itemCount={this.state.displayList.length}
                style={{
                  top:         0,
                  borderColor: 'black',
                  borderWidth: 1,
                  borderStyle: 'solid',
                }}
              >
                {
                  this.displayItem
                }
              </FixedSizeList>
            )
          }
        </Grid>

        { this.state.loading && <Loading backgroundColor="transparent" />}
      </Grid>
    );
  }
}
// const SelectMall = (props) => {

//   const onMallSelect = () => {
//     props.setMallDispatcher(213, 'Marina Square');
//   };

//   const onBackPress = () => {
//     console.log('back pressed');
//   };

//   return (
//     <Grid>
//       <Header
//         title="Select Mall"
//         onBackPress={() => onBackPress()}
//       />
//       <Button
//         onClick={() => onMallSelect()}
//       >
//         Set Mall
//       </Button>
//     </Grid>
//   );
// };

const mapDispatchToProps = (dispatch) => ({
  setMallDispatcher: (id, name) => dispatch(setMall(id, name)),
});

SelectMall.propTypes = {
  setMallDispatcher: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(SelectMall);
